import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import AppShell from "./ui/layout/AppShell";

const isAuthenticated = () => {
  const token = localStorage.getItem("token");

  if (token) {
    return true;
  } else {
    return false;
  }
};

const ProtectedRoute = ({ element: Component }) => {
  const location = useLocation();

  return isAuthenticated() ? (
    <AppShell>
      <Component />
    </AppShell>
  ) : (
    <Navigate to="/" replace state={{ from: location }} />
  );
};

export default ProtectedRoute;
